export const lang = {
  // 顶部导航栏
  header: {
    sy: '首页',
    cpjjfa: '产品与解决方案',
    itfw: 'IT服务',
    hzhb: '合作伙伴',
    gyhq: '关于泓齐',
    zzzs: '资质证书',
    jrwm: '加入我们',
    mxyh: '面向银行的互联网业务',
    yhxd: '银行信贷核心系统',
    zlqy: '助力企业营销新模式',
    hyszh: '行业数字化解决方案',
    jrkj: '金融科技人才输出',
    qfwrck: '全方位人才库'
  },
  bottom: {
    tip1: '一家专业为国内外金融机构提供高效技术支持、优质咨询服务的创新型公司。',
    tip2: '以互联网金融创新服务为目标，紧跟国家“一带一路”发展战略，力求把先进的产品理念、精湛的技术和良好的服务带给全球客户。',
    tip3: '微信扫一扫关注我们',
    tip4: '产品与解决方案',
    tip5: '数字人民币',
    tip6: '区块链',
    tip7: '跨境收款',
    tip8: '海外支付',
    tip9: '联系我们',
    tip10: '联系方式',
    tip11: '邮箱',
    tip12: '官网',
    tip13: '深圳总部',
    tip14: '香港分公司',
    tip15: '张家口分公司',
    tip16: '西安分公司'
  },
  gotop: {
    d: '顶',
    b: '部'
  },
  // 首页
  HellowWorld: {
    yljr: '引领金融科技创新走向世界',
    yljr1: '秉承“安全、高效、优质”的',
    fzzz: '发展宗旨',
    xxjs: '求金融行业信息技术',
    yycx: '应用创新',
    zlycw: '致力于成为全球金融科技行业服务价值的',
    czz: '创造者与领先者',
    lxwm: '联系我们',
    bc: '秉承',
    aqgx: '安全、高效、优质',
    fzzz1: '的发展宗旨',
    wyh: '为银行',
    lsdzd: '量身打造的',
    fwpt: '跨境交易服务平台',
    whzrwt: '精准解决外汇转入问题',
    jybkd: '进一步扩大外汇业务范围，',
    jskthw: '加速开拓海外市场，提供有力、稳定的系统支持',
    text1: '深度场景赋能，构建您的',
    text2: '数字化战略',
    text7: '平台优势',
    text8: '引领',
    text9: '金融科技创新',
    text10: '走向世界',
    text11: '解决方案',
    text12: '满足您的',
    text13: '个性化需求',
    text14: '咨询规划',
    text14_tip: '明确发展愿景,融合自身优秀实践经验和先进技术,深耕金融行业方法论',
    text15: 'IT实施',
    text15_tip: '全面、可靠、高效的IT团队，助力发展愿景变为现实',
    text16: '本地化服务',
    text16_tip: '产品合规、多语言专家团、一对一本地IT队团队，助您快速了解全球市场',
    text17: '综合数字化营销解决方案',
    text17_tip: '全方位数字化营销服务 、本地化内容输出建议 、精准定位不同受众差异 、大数据结合成效驱动分析',
    text18: '来自',
    text19: '各行业的',
    text20: '优秀实践',
    text21: '与我们合作',
    text22: '3年',
    text23: '金融核心系统',
    text24: '我们很享受HQ PAY专业的指导，他们丰富的从业经验、专业且独特的规划建议、高执行力的实施团队帮助我们在短时间内搭建出适合我们、稳定运行的互联网金融核心系统。期待在与HQ PAY持续的合作中不断迭代我们现有系统的功能。',
    text25: '营销方案',
    text26: '我们享受一直以来与HQ PAY的合作。HQ PAY的专家团队对数字营销领域的知识丰富且专业，他们有效的策略及IT团队高效的执行力让我们的项目按期落地，也让我们的营销活动取得极大成效。HQ PAY团队专业高效的能力让我们印象深刻，他们用实力得到我们的信赖。',
    text27: '数字化渠道解决方案',
    text28: '在我们与HQ PAY合作的这些年里，HQ PAY在每个新项目中都能给我们带来惊喜。这次的数字化解决方案，HQ PAY为我们量身打造了多层次、多维度、全方面的数字化重塑方案，深度赋能了我司构建具有前瞻性的全渠道数字化业务模式。期待与HQ PAY在即将开展的新项目中的表现！',
    text29: '全球支付',
    text30: '聚合的全球范围内支付解决方案',
    text31: '助力银行与全球商户、消费者无缝对接',
    text32: '深耕全球差异化产品和服务',
    text33: '数字人民币',
    text34: '抢占万亿级移动支付市场',
    text35: '不受网络限制，双离线仍可支付',
    text36: '国家信用，任何机构和个人不得拒收',
    text37: '区块链',
    text38: '移动支付的',
    text39: '下一个风口',
    text40: '颠覆传统支付业的',
    text41: '“中心”',
    text42: '安全、加密、强可溯',
    gjdq: '国家地区',
    zjtd: '专家团队',
    jrjg: '金融机构',
    zcyy: '支持语言',
    ywcp: '业务产品',
    zdpp: '众多客户的一致认可',
    wxsm1: '微信扫码',
    popup1: '您好！',
    popup2: '完善您的信息，让我们更好的为您服务',
    popup3: '您的姓名',
    popup4: '请输入您的姓名',
    popup5: '您的邮箱',
    popup6: '请输入您的邮箱',
    popup7: '您的联系方式',
    popup8: '请输入您的联系方式',
    popup9: '提交',
    wgnw: '为国内外金融机构提供',
    gxjs: '高效技术支持、优质咨询服务',
    lqb: '力求把',
    xjcp: '先进的产品理念',
    jzjs: '精湛的技术',
    lhdfw: '良好的服务',
    qqkh: '带给全球客户',
    yhzd: '用户主动出示自己付款条形码',
    sjzj: '商家直接扫描即可完成付款',
    djdj: '对接多家银行、第三方支付公',
    zcdj: '司，支持多级商户体系',
    zhsm: '整合市面所有的支付通道，全',
    lghz: '力给合作方提供多途径通道',
    lyfw: '旅游服务',
    lyfwjs: '整合旅游资源，贴合线下场景，把吃、住、行、游、购、娱等各项商家服务融合，形成有效闭环',
    shfw: '生活服务',
    shfwjs: '物业缴费系统集成了业主和租户缴费以及物业相关管理缴费以及银行管理统计，增加便利提升安全',
    zncy: '智能餐饮管理系统',
    zncyjs: '智能餐饮管理系统集成了消费者点餐-服务台接单-后厨接单处理以及事后的统计分析，大大提升工作效率',
    wgfw: '网购服务',
    wgfwjs: '新零售电商平台系统开发解决方案、从单一零售向多元（商品+服务+内容+其他）转化，让线下线上相融合，推动企业转型升级',
    jrfw: '金融服务',
    jrfwjs: '互联网金融平台的建设，打破原有封闭体系，帮助银行转型，融入互联网生态',
    ylfw: '医疗服务',
    ylfwjs: '统一信息流转与通讯大平台，打通医疗环节中的各种参与者，各系统、终端，实现互联网互通，促进信息充分流通',
    yizf: '移动支付',
    hlwzf: '互联网支付',
    kjzf: '跨境支付',
    tysh: '统一商户平台',
    hwdz: '海外电子钱包支付',
    tyfx: '统一分销平台',
    xyfk: '信用风控决策模型',
    znkf: '智能客服模型',
    jzyx: '精准营销模型',
    dhcs: '贷后催收模型',
    dsjy: '电商交易平台',
    dzyf: '电子预付卡交易平台',
    wltz: '网络投资平台',
    wlxf: '网络消费分期信贷平台',
    tyyx: '统一营销平台',
    jfyh: '积分优惠券管理系统',
    zcgl: '资产管理系统',
    zncygl: '智能餐饮管理系统',
    wyjf: '物业缴费系统',
    sbjf: '社保缴费系统',
    jyjf: '教育缴费系统',
    zjzh: '资金账户存管',
    hlwjr: '互联网金融平台',
    ydzf: '移动支付收单（跨境&本地钱包）',
    jhzf: '聚合支付收单系统',
    wygl: '物业管理系统',
    jyzx: '教育在线缴费系统',
    hlwty: '互联网统一电子账户系统',
    jpz: '柬埔寨电子钱包系统',
    hlwtrz: '互联网投融资服务平台',
    zncyxt: '智能餐饮系统',
    shdzhyk: '商户电子会员卡管理系统',
    ljxq: '了解详情',
    cgal: '成功案例',
    hqwlkj: '深圳市泓齐网络科技有限公司',
    gsdh: '公司电话：',
    gsyx: '公司邮箱：',
    gswz: '公司网址：',
    gsdz: '公司地址 :广东省深圳市南山区桃源办平山大园 工业区13栋（鸿莱科创楼）4楼405室',
    wxsm: '微信扫码关注我们',
    beian: 'Copyright2017-2018 深圳市泓齐网络科技有限公司',
    beian2: '粤ICP备18002099号-1'
  },
  // 加入我们
  joinUs: {
    t1: '和我们一起，让进步发生',
    t2: '期待',
    t3: '你的加入',
    t4: '营销运营类',
    t5: '技术类',
    t6: '职能类',
    t7: '管理类',
    t8: '中高级java开发工程师',
    t9: '安卓开发（全栈）高级/资深',
    t10: '大数据开发工程师',
    t11: '高级测试工程师',
    t12: 'java开发实习生',

    t14: '',
    t15: '互金产品经理',
    t16: '市场销售',
    t17: '销售顾问',
    t18: '人力资源招聘主管',
    t19: '招聘专员',
    t20: '行政专员',
    t21: '部门主管',
    t22: '项目经理',
    t23: '有积分营销相关项目经验及管理能力',
    t24: '1、熟悉掌握spring boot/spring cloud等技术；',
    t25: '2、熟悉使用redis、rocketMQ、mybatis、mysql；',
    t26: '3、熟悉软件开发领域精益与敏捷模式，dveops理念及相关规范和流程，精通持续集成、持续交付相关技术，熟悉构建工具如jenkins、gitlab等；',
    t27: '4、具备良好的分析解决问题能力，好学、责任心强，思维缜密敏捷，良好的对外沟通和团队协作能力；',
    t28: '5、对业务能有深度理解且有前瞻性，有良好的系统分析、业务分析能力；',

    t29: '1、熟悉安卓app客户端&iosAPPA客户端&移动H5开发移动端全栈；',
    t30: '2、有实际安卓、ios APP开发经验；',
    t31: '3、熟悉银行系统类业务；',
    t32: '4、有处理安卓（鸿蒙）客户端、ios客户端混合开发的架构研发类经验优先；',
    t13: '5、具备良好的沟通能力，分析解决问题能力，优秀的团队协作精神。',

    t33: '1、本科学位，具有5年及以上的大数据分析和开发经验，熟悉全流程数据处理;',
    t34: '2、熟悉数据仓库架构，有数据仓库/数据集市建设经验;',
    t35: '3、熟悉ETL流程，熟练掌握数据清洗和数据开发技能;',
    t36: '4、熟悉Hadoop生态主流大数据组件，能处理大数据集群的异常问题；',
    t37: '5、熟练使用Hql、python、sparkSql处理数据报表和分析需求；。',
    t38: '6、熟悉Linux相关操作和Shell编程；',
    t39: '7、具备数据敏感性，对大数据处理和分析技术有丰富的经验和热情；',
    t40: '8、具备分析问题和解决问题的能力，勇于解决难题；',
    t41: '9、具备较强的沟通表达能力、学习能力和协作推进能力;',
    t42: '10、有银行数据处理经验或其他金融领域数据管理经验尤佳；',
    t43: '11、 有实时数据采集、实时计算设计开发、机器学习经验者优先；',

    t44: '1、本科及以上学历，计算机相关专业，有3-5年以上项目测试经验',
    t45: '2、参与银行项目测试、熟悉敏捷团队流程，近半年有APP端测试经验',
    t46: '3、熟悉测试流程及规范、测试原理，熟练掌握测试方法，有较好的沟通和协调能力',
    t47: '4、参与自动化设计、开发和实施经验，有自动化测试框架搭建经验',
    t48: '5、熟练使用任意一种常用的自动化测试工具（Selenium、Appium、Jmeter、MeterSphere等），能熟悉测试常用工具；如Jira、Xmind、Fiddler、Visio',
    t49: '6、掌握 java，python、sql、shell 的基础应用；',
    t50: '7、喜欢研究新技术，能快速学习。',

    t51: '1、熟悉java开发，有开发基础能力者优先；',
    t52: '2、熟悉spring cloud；',
    t53: '3、熟练使用浏览器、postman等工具进行前端调试；',
    t54: '4、良好的代码编写风格，有团队合作精神，为人踏实正直，责任心强，有良好沟通能力和学习能力；',

    t55: '1、熟悉Oracle、MySQL数据库及体系架构，可以独立安装部署数据库，对数据库进行物理和逻辑备份；',
    t56: '2、熟悉Oracle DataGuard高可用架构，可以独立搭建部署ADG；',
    t57: '3、熟悉MySQL 主从复制和MGR高可用架构，可以独立部署；',
    t58: '4、工作年限要求：3年以上。',
    t59: '1、4年以上产品经理工作经验，本科或以上学历，金融或计算机专业优先考虑；',
    t60: '2、有银行系统产品设计经验，有银行金融工作经验者优先，对银行核心系统及产品有深入理解；',
    t61: '3、熟悉产品实施过程，包括需求分析，产品设计、流程设计、界面设计和可用性测试等；',
    t62: '4、工作年限要求：4年以上。',
    t63: '深圳市泓齐网络科技有限公司（总公司）',
    t64: '广东省深圳市南山区西丽街道石鼓路深圳万科云城国际创新谷3期7栋C座502',
    t65: '深圳市泓齐网络科技有限公司（张家口公司）',
    t66: '河北省张家口市万全区孔家庄镇民主街区医院西底商二楼',
    t67: '公司地址',
    t68: '深圳市泓齐网络科技有限公司（西安公司）'
  },
  // 产品与解决方案
  ProductSolutions: {
    index: {
      cpyjjfa: '产品与解决方案',
      xydzf: '新一代支付',
      dsjfx: '大数据分析',
      hlwjr: '互联网金融',
      zhxd: '综合信贷',
      szhyxfw: '数字化营销服务',
      szhcj: '数字化场景',
      yhhyjjfa: '银行行业解决方案',
      kjjr: '跨境金融',
      jryw: '金融业务',
      hxjr: '核心金融'
    },
    kjskxt: '跨境收款系统',
    tips1: '助力企业加速开拓海外市场提供有力的系统支持',
    kjzfxt: '跨境支付系统',
    tips2: '提供移动化、智能化、云化的聚合支付平台',
    hwxnkglxt: '海外虚拟卡管理系统',
    tips3: '通过电子渠道申请开立的无实体介质的虚拟借记卡',
    hwyckhxt: 'E-KYC海外远程开户系统',
    tips4: '使用先进的专有反欺诈算法进行真人身份验证',
    qklxt: '区块链及web3系统',
    tips5: '基于云区块链服务创建、部署的区块链技术平台服务',
    fxqxt: 'AML反洗钱系统',
    tips6: '为银行构建灵活、机敏、高可靠的反洗钱信息监测系统',
    sjyhjwyxt: '手机银行及网银系统',
    tips7: '一对一贴身打造手机银行APP及网银系统',
    dzqbxt: '电子钱包系统',
    tips8: '集成丰富的增值应用，让支付不止于‘付’',
    szrmb: '数字人民币',
    tips9: '为银行量身打造数字人民币系统',
    hlwhxxt: '互联网核心系统',
    tips10: '互联网丰富的场景创新、产品创新、快速迭代提供功能支撑',
    zjtgxt: '资金托管系统',
    tips11: '为各类交易平台提供账户管理，收付款，结算对账等交易服务',
    dwqlczhxt: '大湾区理财综合系统',
    tips12: '助力银行促进大湾区跨境投资便利化',
    tips13: '先买后付，打开购物新天地',
    wlxf: '网络消费分期及现金贷服务',
    tips14: '基于互联网的纯信用贷款业务',
    xdsplc: '信贷审批流程管理系统',
    tips15: '可根据业务类型灵活设置审批风控流程。',
    fkjcmx: '风控决策模型',
    tips16: '结合线上、线下海量数据构建信用风险体系',
    dhcs: '贷后催收模型',
    tips17: '为金融机构量身定制的一款成熟的催收业务管理系统',
    xcxkf: 'APP及小程序开发',
    tips18: '一站式软件、小程序设计开发服务',
    zmjtgxt: '招募及推广系统',
    tips19: '为团长营销量身打造',
    hlwqdyx: '互联网渠道营销平台',
    tips20: '适用于出行、外卖、电影票、视频、游戏、加油卡等服务场景',
    zhjfglxt: '综合积分管理系统',
    tips21: '一站式场景生活权益服务',
    qyhx: '权益核销SaaS服务平台',
    tips22: '适用于出行、外卖、电影票、视频、游戏、加油卡等服务场景',
    hyyf: '会员预付卡管理系统',
    tips23: '互联网玩专业会员卡综合服务商助力商户效益提升',
    dszhjypt: '电商综合交易平台',
    tip24: '集团购、电商零售、批发于一体，帮助企业低成本快速构建网上商城系统',
    jyjfglxt: '教育缴费管理系统',
    tips25: '依托微信体系建设的教育缴费平台',
    wyglxt: '物业管理系统',
    tips26: '“智慧物业” 综合信息服务平台',
    zycf: '中央厨房餐饮配送系统',
    tips27: '借助大数据云服务为中央厨房量身定制全流程的解决方案',
    jrkjrcsc: '金融科技人才输出',
    tips28: '构建企业人才库,为企业提效降本',
    BankingIndustrySolutions: {
      zncy: '智能餐饮管理系统',
      jyjf: '教育缴费系统',
      wyjf: '物业缴费系统',
      zjzh: '资金账户存管',
      sbjf: '社保缴费系统',
      yhzj: '银行中间服务',
      hlwjr: '互联网金融平台',
      AccountFunds: {
        zjzh: '资金账户存管',
        zjzhdy: '资金账户存管定义',
        wljd: '网络借贷资金存管业务，是指商业银行作为存管人接受委托人的委托，按照法律法规规定和合同约定，履行网络借贷资金存管专用账户的开立与销户、资金保管、资金清算、账务核对、提供信息报告等职责的业务。存管人开展网络借贷资金存管业务。',
        cptd: '产品特点',
        yejs: '业务介绍'
      },
      EducationPayment: {
        jyxt: '教育系统解决方案',
        jyhy: '教育行业收费现状',
        xxsf: '学校收费具有收费群体大，收费时间集中，收费数据大等特点，由于学校财务人员有限，工作量大的问题较为突出；面临的对象群体大，收费群体的变动性强，同时收费项目具有多样化，财务人员无法精确掌握每个收费对象的缴费状况；面对庞大的收费群体及多样化的收费项目，财务人员无法在有限时间内对数据进行分类统计核算，耗时耗力效率低',
        jyfy: '教育费用需手动收取，费时费力,少量线上收取,无法为异地的家长提供收费渠道；传统柜台收取现金，收费后不能与实际收款费对应需要财务人员进行二次核对核销；学生调动班级后，跟踪学生的缴费情况困难；手动收取人员成本较高；收取后现金管理成本高；收取后现金管理成本高，存在资金风险；多年级多班级多个不同科目收费后归集难，收费包含多项内容，需要人工清分至不同账户。',
        hqwk: '泓齐网科教育系统产品简介',
        jfyq: '缴费延期不用到场，可以使用手机APP查询纪录和缴费；通过电子化手段，降低人工投入成本、设备耗材投入成本等运营成本；电子精准扣费，杜绝逃费、漏费情况；减少由于人工收费导致的问题(假币、错收、漏收)；云平台管理，大数据分析，帮助管理方掌握各种信息，拓展更多服务；客户提供更多扩展智能化的服务，网络充值、预定车位等；开放的数据接口，应用更便捷',
        fb: '方便、快捷',
        jysj: '节约时间、成本',
        aq: '安全，高效',
        tz: '拓展',
        lcsyt: '泓齐网科教育系统核心场景业务流示意图',
        ewm: '二维码为载体',
        yxx: '以学校为单位为每一班级生成一个专属二维码该二维码可贴至学校门口、班级内、发送给在外地的家长用任意工具扫取后进入收费页面，直接交费即可',
        ygzh: '以公众号为窗口',
        wyw: '为业务提供微信公众号、支付宝服务窗服务家长可在该入口获取相应的家长服务',
        xih: '信息化为根本',
        dtxx: '打通学校管理系统与收费系统通过信息化、移动互联网化的方案突破收费的时空限制通过技术手段降低人工核销对账的难度与成本'
      },
      IntermediateBankService: {
        zjyw: '中间业务平台解决方案',
        cpdy: '产品定义',
        szwg: '随着我国金融业改革的不断深入发展，各银行间的竞争也日趋激烈，利用技术、信息、机构网络、信誉等种种优势，积极拓展中间业务服务，对我国商业银行具有十分重要的战略意义。建立开放性好、可扩展性强、新业务开发快捷、系统运行稳定和维护简便的银行中间业务平台，将成为银行大力发展中间业务的有效手段。泓齐中间业务平台是一套统一的中间业务交易处理和第三方接口管理的系统平台，它支持保险、证券、税务、财政以及各类代缴费单位的统一接入和业务处理。该平台采取基于分布式的技术架构，有效得区分各业务的处理。',
        ywjs: '业务介绍',
        ywbk: '业务包括对公代理（代发工资、补贴等），代缴水电煤，财政非税管理、法院查冻扣，反电信诈骗管理，招标办保证金管理等。'
      },
      InternetBanking: {
        zjyw: '中间业务平台解决方案',
        cpdy: '产品定义',
        hlwjr: '互联网金融平台（ITFIN）网络借贷模式在服务小微企业方面有着独特的优势。小微企业主以个人名义，通过中介获得融资，既能做到方便快捷，又能有效利用社会闲散资本，再加上机构通过网络能有效降低服务成本，符合小微企业需求。P2P网络借贷平台指个人与个人间通过网络平台达成的小额借贷交易。借款者可自行发布借款信息，包括金额、利息、还款方式和时间，实现自助式借款;借出者根据借款人发布的信息，自行决定借出金额，实现自助式借贷。',
        ywjs: '业务介绍',
        ptdjs: '互联网金融平台的建设，打破原有的封闭体系，帮助银行转型，融入互联网生态。'
      },
      PropertyPayment: {
        wygl: '物业管理系统解决方案',
        sfxz: '物业管理收费现状',
        rjd: '如今的物业管理，多以传统柜台收取,少量线上收取,无法为远程不在家的业主提供收费渠道；传统柜台收取现金，收费后不能与实际物管费对应需要财务人员进行二次核对核销，电汇交费后，无法与实际物管费对应，需要财务人员进行二次核销。柜台收取人员成本较高，收取后现金管理成本高，传统线上收取方式业主接受难度大，成本高；多个不同物业收费后归集难，收取物业费包含多项内容，需要人工清分至不同账户。大多数物业管理服务公司收费率只能达到50%-70%左右，有的甚至只有30%，传统柜台收费模式人工成本高，无法及时有效地将发生的物业费推送给业主及时收费。',
        sqfs: '收取方式单一',
        sffs: '收费方式成本过高',
        sfh: '收费后对账难',
        gj: '归集清分难',
        cpjs: '泓齐网科物业管理系统产品简介',
        jfyq: '缴费延期不用到场，可以使用手机APP查询纪录和缴费；通过电子化手段，降低人工投入成本、设备耗材投入成本等运营成本；电子精准扣费，杜绝逃费、漏费情况；减少由于人工收费导致的问题(假币、错收、漏收)；云平台管理，大数据分析，帮助管理方掌握各种信息，拓展更多服务；客户提供更多扩展智能化的服务，网络充值、预定车位等；开放的数据接口，应用更便捷',
        hlw: '互联网、方便、快捷',
        jysj: '节约时间、成本',
        aq: '安全，高效',
        tz: '拓展',
        ywsyt: '泓齐网科物业管理系统核心场景业务流示意图',
        ewm: '二维码为载体',
        ewmjf: '二维码交费：物业公司将每户专属二维码发放给物业，业主/租客在家扫码即可交费',
        gzh: '以公众号为窗口',
        wyw: '为业务提供微信公众号、支付宝服务窗服务业主/租客可在银行/物业公司的公众号点击链进行交费',
        xxh: '信息化为根本',
        dtwy: '打通物业管理系统与收费系统通过信息化、移动互联网化的方案突破收费的时空限制通过技术手段降低人工核销对账的难度与成本'
      },
      SmartCatering: {
        xtjj: '泓齐点餐系统简介',
        zzdc: '泓齐自助点餐管理系统是本公司经过对现今餐饮行业及行业将来发展趋势进行深入调查，结合众多酒楼餐饮行业客户管理需求以及食客现今的就餐习惯，由本公司专业技术开发团队潜心开发，全力打造的一款面向中餐、西餐、海鲜酒楼、特色餐厅酒楼的餐饮管理系统。系统操作简单，功能齐全，能帮助您的餐厅酒楼利用计算机强大的数据处理能力和流程优化能力，实现自动化管理，简化餐厅的工作管理流程，减少浪费及人为管理的疏漏现象，优化酒楼的管理资源提高整个餐厅的运作效率。系统对菜品的各类做法及显示有很好的支持功能，支持临时菜品、套装菜品。',
        cptd: '产品特点',
        hybj: '行业背景及自助点餐机的诞生',
        xjd: '现阶段的餐饮行业一直保持着高速增长的态势，已成为了世界消费需求市场中增长幅度最高、发展速度最快的行业之一。而在当前餐饮行业日趋激烈的竞争中脱颖而出，是每一位餐饮业经营者所追求的目标。自助点餐机也正是在这样的背景之下走进了餐饮行业。',
        szkj: '随着科技的发展，不断降低的硬件成本、不断进步的技术，都在推动着自助点餐机不断地推陈出新，我们相信，自助式点餐模式必将成为餐饮服务行业的一个发展趋势，成为引领餐饮市场前进的完整形主流科技产品',
        dcj: '点餐机的设计理念',
        cyhy: '⑴令餐饮行业全面进入自助式服务时代传统的人工点餐，会因客人及服务人员的语言，态度，菜单上菜品更新不及时，或者是其它的某种原因，造成某种不必要的麻烦及纠纷，而采用自助式点餐服务之后，在某种程度上可以有效的杜绝这些无必要的纠纷及麻烦，同时，让服务员腾出更多精力，从而更优质为顾客服务。令企业与客人双方都能享受到舒适便捷的服务就餐模式，这将是餐饮业发展的最终趋势。',
        ydcy: '⑵引导餐饮行业信息技术化的变革在科技的时代，自助点餐机不仅科学地缩短了食客点单、下单、买单的流程、避免了人为失误；而且还提供了多种管理模式，如：仓储管理，报表管理，会员管理，信息采集更新，买单折扣优惠等功能，相比传统的人工管理，使用自助点餐机将大大减轻人力投入，我们相信自助点餐机的出现将带动一场信息化点单理念的革命。技术变革，势在必行！',
        rjyd: '软件优点',
        xtsy: '系统适用范围',
        zcjl: '中餐酒楼、海鲜餐厅酒楼、特色酒楼、连锁餐饮企业',
        zncy: '智能餐饮管理系统流程',
        xfzdc: '消费者点餐',
        ctsm: '餐台扫码点餐：消费者可扫取桌面二维码点餐远程点餐：消费者可在互联网直接订桌，点餐',
        hcjd: '后厨接单',
        xdgl: '后厨可根据下单情况，备菜',
        fwtjd: '服务台接单',
        jdgl: '接单管理：服务员可随时管理订单、买单等操作',
        tjfx: '统计分析',
        yyksh: '运营可事后根据历史订单情况进行统计分析，为后续备料，增加翻太台率提供依据',
        jscb: '①为业主节省成本，拓展利润',
        gnws: '②功能完善，适用性强',
        cbfx: '③为餐饮行业经营者提供了成本分析，利润分析，仓储管理等诸多功能',
        czjd: '④图形化界面，操作简单，无需专业培训即可正常使用'
      },
      SocialSecurityPayment: {
        sbgl: '社保管理系统解决方案',
        wsb: '“微社保”人脸识别系统，是聊城农商银行与东昌府区人社局强化战略合作，针对辖区广大职工群众，推出的一款“便民服务”产品；该系统依托人社局社保信息数据库，借助腾讯人脸识别技术，通过对人脸识别验证，对参保人员的身份进行确认。目前，“微社保”系统已对东昌府区参保人员实现了全覆盖。',
        yyzd: '“微社保”上线意义重大：一是方便了参保职工群众。在东昌区参加社保的群众，不用到人社局进行现场认证，只要手机关注一下APP，在较短的时间内，即可完成“线上认证”，让群众切实体验到“极简金融服务”；该系统打破了社保资格认证的时间、空间和地域限制，极大了方便了行动不便的老人、异地工作人员，免去了路途奔波之苦。二是提升了社保管理水平。社保局通过“微社保”管理系统，可精准查询人脸认证的结果，及时更新、维护社保人员信息数据库。另外，不再需要组织现场认证和张榜公示，极大地提高了社保机构的工作效率、降低了管理成本；也对“冒领社保资金”不法行为筑起了一道坚实的“防火墙”。'
      }
    },
    BigData: {
      znkf: '智能客服模型',
      jzyx: '精准营销模型',
      xyfk: '信用风控决策模型',
      dhcs: '贷后催收模型',
      CreditriskControl: {
        xyfktd: '信用风控特点',
        dq: '当前，经济下行导致中小企业经营成本不断增加，产品销售价格因结构原因和市场原因相对走低，企业利润空间被进一步压缩，许多中小企业陷入经营困境，导致企业经营风险加大、连锁性风险陡增、潜在信用风险上升、企业主的道德风险陡升，与此同时经济下行也使得个人信贷中的逾期率陡增，不良贷款率上升。',
        yy: '运用金融物理学原理和机器学习方法，基于大数据分析技术实现智能化、全面量化风险管理和辅助决策。',
        fxmn: '风险模拟',
        fxdt: '风险动态',
        jk: '监控',
        fxle: '风险类型',
        sb: '识别',
        yjfx: '预警风险',
        dlfx: '度量风险',
        xyfk: '信用风控',
        xyfklc: '信用风控流程',
        shcj: '数据采集',
        gzgl: '规则管理',
        dcfx: '调查分析',
        algl: '案例管理',
        bbfx: '报表分析',
        xyfkzb: '信用风控指标',
        qyzb: '企业指标',
        cwzb: '财务指标',
        hgzb: '宏观指标',
        hyzb: '行业指标',
        grzb: '个人指标',
        hg: '　宏观　',
        hy: '　行业　',
        gr: '　个人　',
        zbpl: '指标频率',
        rdzb: '日度指标',
        ydzb: '月度指标',
        jdzb: '季度指标',
        ndzb: '年度指标'
      },
      LoanCollection: {
        dhcs: '贷后催收',
        zdhlw: '是针对互联网金融行业、P2P网贷系统、传统小贷行业、网络投融资平台以及银行信用卡业务的贷后催收管理退出的完整催收解决方案，结合移动智能终端方便外放催收，满足银行对催收过程监管的要求，在系统部署安全能力、网络完全管控、数据安全管控等方面均有高标准，保障催收业务安全、规范、各部门协调有序工作。',
        dhcsgn: '贷后催收-功能',
        jck: '贷后催收-决策库',
        jcblk: '决策变量库',
        khxx: '客户信息',
        zhxx: '账户信息',
        jyxx: '交易信息',
        cslc: '催收历程',
        ajfl: '案件分类、逾期阶段、风险等级、案件状态',
        yqcs: '近6月累计逾期次数、近6月最大逾期CD、近3月BP次数、···',
        yqts: 'CD、逾期天数、余额最低还款额、本金、余额额度比、···',
        csm: '城市码、产品码、性别、学历、VIP、···',
        sjzh: '数据整合',
        csxt: '催收系统和业务系统、征信接口、数据仓库等系统或接口进行数据交互，保证催收系统内部数据的完整性',
        lczh: '流程整合',
        csdl: '催收队列对不同的催收手段如电话催收，上门催收、发物催收、外包催收、电邮等进行工作的流程',
        qdzh: '渠道整合',
        dxxt: '催收系统和短信系统、电邮系统、客服系统、进行数据交互，保证催收渠道的完整性',
        htzc: '后台支撑',
        sjfw: '催收系统在设计发物计算的部分提供参数设置支撑，提供实时的监管功能和丰富的报表体系对业务发展提供支撑',
        fxgl: '风险管理',
        pdtx: '催收系统应有完善的风险判定体系，能对逾期账户进行多个维度的账户划分和状态界定，并通过规则处理形成特定的催收队列'
      },
      PrecisionMarketing: {
        jzyy: '精准营销-特点',
        yrwb: '以人为本是精准营销的发展趋势，把个体变为营销的核心，尤其是多中心的个体形成的关系网络营销，以带动更多的体验营销、口碑营销和社群营销，将互联网上社会化网络服务转化为生产力。',
        xyx: '营销行为效益性',
        yxx: '营销策略有效性',
        zdx: '目标对象针对性',
        wdx: '目标对象稳定性',
        zsgl: '知识管理',
        dgc: '的过程',
        ff: '精准营销-方法',
        sjsj: '通过数据收集，基于通信行为、上网数据等，可对客户行为特征进行解析，通过对信息进行关联、参照、聚类、分类等方法分析，得到有价值的用户行为',
        tzjz: '通过客户行为特征机制，作为客户分析的基础。可以通过手机和整理开放式分类目录、各大行业主流网站、热门门户网站以及参考互联网分类行业标准来制定。同时建立行为特性调整的动态机制',
        swcs: '基于用户上网次数、流量、时间段等属性，可以给用户增添标签；针对上网较少的用户，可以通过基础数据特征(如年龄、性别、流量、终端等基础资料，使用数据挖掘工具和方法生成对应模型',
        khtzfx: '客户特征分析',
        sr: '年龄、地域、学历、婚姻、职业、收入',
        lrlfx: '利润率分析',
        gdjz: '通过分析哪些客户能产生更大的利润商品具有更多的利润率，找更大价值商品或服务，为企业创造更多价值',
        qxfx: '消费倾向分析',
        xfxq: '了解客户消费兴趣，分析行为习惯、对不同客户的需求提供具有个性化、差异性的服务，并以研发、生产、销售有针对性的产品或服务，以达到企业与消费者都能获取利益和满足',
        zcdfx: '客户忠诚度分析',
        lzkh: '运用营销手段留住客户，深度挖掘潜在客户，分析客户感兴趣程度，使之成为回头客，利用回头客拉动新客户、完善客户群体，并预测如何提高客户的忠诚度的途径，为企业创造更大的发展空间',
        xwfx: '消费行为分析',
        srfx: '对客户消费行为所产生的数据进行深入分析，找出更有利用价值的关键客户信息，并制定有针对性的营销策略'
      },
      SmartCustomerService: {
        znkftd: '智能客服特点',
        rgznjs: '基于强大的人工智能技术',
        yyfxnl: '精准的语义分析能力，准确判断用户意图',
        dhwdnl: '流畅自然的中文对话问答能力',
        zwxxnl: '丰富的上下文场景及强大的自我学习能力',
        zskxt: '强大的智能知识库系统',
        jrfa: '提供最优的接入方案',
        dhty: '对话体验',
        lczrlx: '流畅自然领先的增强学习模型，让客服机器人聊天对话更接近真人情感交互23类情绪识别及多维情感表达，让机器人更拟人化记忆系统通过深度记忆系统与用户画像，让机器人更懂你',
        lxjs: '领先技术',
        yyljkf: '语义理解开放域聊天准确率81.64%，垂域技能准确率96.34%知识图谱千万级实体及关系知识，支持逻辑与关系的知识推理多轮对话开放域聊天与垂域技能超过5轮的上下文对话能力',
        sjyl: '数据语料',
        jcltk: '基础聊天库通用对话语料150亿条，儿童对话语料10亿条基础知识库问答知识库1亿条，高频知识库1000万条',
        hyrk: '智能度高对话和语义准确度受到用户及行业认可',
        ylkgn: '语料库强大基于语义技术且支持批量上传的语料库功能',
        gglyl: '场景丰富能够应用在网站、软件及智能硬件各个领域里',
        jlqq: '响应快速毫秒级响应速度，轻松应对巨量请求',
        jnfw: '技能全面提供了涵盖几乎所有生活领域的技能服务',
        kfxns: '接入方便只需简单的注册激活便可让自己的产品成为客服小能手',
        sdyh: '针对多领域知识特点深度优化',
        ppnl: '快速精准的语料库匹配能力',
        drygl: '方便快捷的语料库导入与管理',
        yjcp: 'PC端可快速接入PC端、移动端及硬件产品',
        dzfsjr: 'APP支持API、SDK等多种方式接入',
        kfjqr: '后台服务提供免费的虚拟客服机器人API'
      }
    },
    InternetBanking: {
      dsjypt: '电商交易平台',
      zcglxt: '资产管理系统',
      wltrzpt: '网络投融资平台',
      yhjglxt: '积分优惠劵管理系统',
      tyyxpt: '统一营销平台',
      yfkjypt: '电子预付卡交易平台',
      wlxffqpt: '网络消费分期信贷平台',
      AssetManagement: {
        zcglxt: '资产管理系统',
        gysgl: '资产管理系统由：供应商管理、设备台帐、设备档案、设备维修、设备报废、设备技术状况、设备调拨、查询管理、设备数据导入、系统管理组成。此管理系统覆盖经营管理部门对固定资产的管理，将管理流程体系完全网络化、流程化。对设备进行综合管理，达到的全面规划、合理配置、优先选购、正常使用、安全运行、适时改造和更新。',
        ywjs: '业务介绍',
        cpgc: '产品工厂',
        gdcsh: '产品配置高度参数化,支持产品创新和聚合,能够快速响应市场',
        flsch: '支持利率市场化/费率市场化',
        mxlc: '面向流程、服务的设计',
        jzcl: '支持作业集中处理，流程自动化、精简化',
        bjdywfw: '一站式不间断业务服',
        xsfu: '支持7×24小时服务',
        qfw: '全方位风险控管',
        czgk: '支持基于工作流的操作管控',
        gfktz: '规范可拓展的IT架构',
        zjhsj: '基于SOA架构的组件化设计，易于业务的分拆和组合，满足业务扩张',
        yjtz: '支持跨平台部署，保障硬件投资'
      },
      EcommerceTransaction: {
        kjdszf: '跨境电商支付解决方案',
        fzxz: '跨境电商支付发展现状：跨境电子商务的定义主要由两部分构成，第一、来自不同国家的交易双方在进行支付结算时借助互联网平台，第二、在商品的流通方面主要通过跨境物流进行运输，这种交易形成的跨国商业活动便是跨境电商。我国跨境电商发展的前期，通关物流与相关的结算方式是在线交易的主要结算形式，比如传统的邮政汇款，或是银行转账，同时信用证也是主要方式。最近几年以来，伴随电子商务的发展，出现了大批包裹海外仓转运模式，同时第三方支付平台也在不断完善发展中，信用卡支付、邮政汇款、银行转账多种支付方式也在不断创新发展中。在国家政策支持下，我国跨境电商发展保持快速增长态势。',
        kdwt: '解决跨境电商微信开店问题'
      },
      ElectronicPrepaidCard: {
        dzyfk: '电子预付卡交易平台',
        fwgjzl: '服务国家战略、引领行业发展、助力门店升级，以顾客经营为中心，再创会员营销新辉煌。全国领先的线上线下会员营销、非会员顾客经营一站式解决方案服务商，为各行业商家提供市场最具竞争力的电子会员管理系统助力门店拥抱互联网，提高营业额，提升竞争力',
        cpys: '产品优势',
        fwjh: '服务计划',
        xfsy: '消费收银',
        mydhf: '满意度回访',
        yltk: '引流拓客',
        hyyx: '会员营销',
        gklc: '顾客留存',
        wxqf: '微信群发',
        zngj: '智能跟进'
      },
      InternetConsumption: {
        wlxf: '网络消费分期信贷',
        fqxdxt: '网络消费分期信贷系统是一款基于大数据智能风控的小额信贷系统，通过整合各种智能化工具、数据、通信、规则实现自动进件、自动审批、自动放款、自动还款、自动催收等环节，使信贷业务的开展实现智能化、可控化、简单化、快速化。此款系统适用于极速贷、发薪日贷、零用贷、消费贷款等所有脱离于场景的小额现金贷款。系统内置一整套信贷风控体系，即使您没有做过贷款类业务，不知道如何风控，通过使用互融云现金贷业务也可以快速开展。如果您想扩展业务，我们还为您提供了标准的接口，与P2P对接、与引流平台对接、与车贷、抵押贷业务整合等，都可以通过这套系统实现。',
        xtts: '系统特色',
        gnjg: '功能结构'
      },
      OnlineInvestment: {
        trzpt: '网络投融资平台',
        cqyd: '存钱越多，收益越多收益每天累计增加账户余额随用随取，安全便捷零风险',
        tstz: '天使投资',
        gqtz: '股权投资',
        zqtz: '债券投资'
      },
      PointCouponManagement: {
        yhjgl: '积分优惠券管理系统',
        cpdz: '01.从产品制定到方案策划',
        jjqy: '解决企业礼品单一,缺乏吸引力的问题为企业打造营销新模式',
        hdjf: '02.获得积分',
        glyh: '鼓励用户与企业交互/拉动消费',
        xfjf: '03.消费积分',
        tskh: '提升客户对品牌的信任感,增强客户满意度',
        wdcp: '我的产品',
        sczb: '01.市场转播 增加客户量',
        sjwl: '品牌与社交网络同步、扩大销售和市场、提高和知名度形式新颖多样，在客户了解购买产品，对企业有一定的了解，帮助企业做出推广，推荐介绍新客源，充分利用平台积分和会员体系，灵活分配资源',
        dqd: '多渠道精准引流',
        whkh: '02.维护客户，提供完整的品质服务',
        jllh: '建立良好的信誉度，倾听客户意见，想客户所想，急客户所急，做好售后服务，完善功能需求，视产品质量到运营服务为平台的第一位',
        jsgj: '及时跟进/用心倾听',
        yxhd: '03.营销活动创意多样，贴近品牌',
        cydy: '节日营销、会员活动丰富多样，增强客户参与度',
        yhjfgl: '04.优化积分管理',
        ppqyyh: '匹配企业用户特性，进行积分分类管理，刺激客户有目标进行消费，留存客户提高营销转化率',
        yhzcd: '提升用户忠诚度'
      },
      UnifiedMarketing: {
        tyyx: '统一营销平台',
        fwpt: '统一营销服务平台以供应链系统为支撑，是基于现代互联网技术的多渠道模式统一营销服务管理体系。整合线上与线下交易模式，覆盖企业经营管理应用各个方面。统一营销服务管理能有效掌控通路情况，敏捷捕捉消费者需求，快速响应市场变化，规避经营风险；以市场为导向，优化部署营销资源，协同产销、供应与服务，帮助企业构建敏捷的经营管理平台；通过电子商务等创新通路模式整合流通企业上下游产业链资源，共享数据与服务，提升供应链效率。',
        tgtx: '市场推广体系',
        djsc: '搭建市场竞争情报系统，为市场推广奠定基础精细化营销活动与费用管理',
        ywtx: '营销业务体系',
        sxcw: '实现财务物流商务一体化和产销一体化、多渠道整合平台实施客户全生命周期与高效物流执行管理平台',
        zxtx: '销售执行体系',
        tdjh: '基于团队计划、活动、培训等的协同工作平台基于路线规划、拜访计划、移动销售的销售执行平台',
        gxtx: '客户关系体系',
        glyypt: '搭建消费者与会员管理运营平台，提供差异化服务整合呼叫中心、ICC、MA、Ec等多 接入服务平台',
        fxtx: '决策分析体系',
        znfxpt: '为营销团队打造智能分析平台为管理者打造决策支持平台'
      }
    },
    NewPayment: {
      ydzf: '移动支付',
      hlwzf: '互联网支付',
      kjzf: '跨境支付',
      dzqbzf: '海外电子钱包支付',
      fxpt: '统一分销平台',
      glpt: '统一商户管理平台',
      CrossborderPayment: {
        kjzffz: '跨境支付发展',
        xqbdts: '随着人们跨境消费的需求不断提升以及相关政策的逐步规范化，跨境支付有望迎来快速增长，伴随着应用场景的扩容以及盈利模式的多样化，预计到2020年行业容量将接近200亿元。同时从行业格局看，跨境支付牌照的壁垒正在弱化，不同支付企业提供的支付服务模式也在分化。',
        zyyycj: '当前跨境支付的主要应用场景集中在跨境电商、跨境旅游以及留学教育等三个领域，截至2015年这三个领域本身的市场规模分别达到了5.4万亿、1.2万亿和0.42万亿元，随着这三个领域的进一步扩容以及跨境支付向其他领域的拓展，我们保守估计到2020年跨境支付行业通过收取手续费达到的市场容量将达到197.9亿元。同时行业的盈利模式也将逐步多样化，由过去的以手续费为主向手续费、供应链金融、综合一体化方案等多种盈利模式演进。',
        kjzftd: '跨境支付特点',
        kjzfsy: '跨境支付属于电子支付方式的一种，因而具有电子支付的特征，但因其与移动通信技术、无线射频技术、互联网技术相互融合，又具有自己的特征。',
        ssxd: '1.随身携带的移动性，消除了距离和地域的限制。结合了先进的移动通信技术的移动性，随时随地获取所需要的服务、应用、信息和娱乐。',
        bssjdd: '2.不受时间地点的限制，信息获取更为及时，用户可随时对账户进行查询、转账或进行购物消费。',
        ydtxjs: '3.基于先进的移动通信技术和简易的手机操作界面，用户可定制自己的消费方式和个性化服务，账户交易更加简单方便。',
        ysjwzt: '4.以手机为载体，通过与终端读写器近距离识别进行的信息交互，运营商可以将移动通信卡、公交卡、地铁卡、银行卡等各类信息整合到以手机为平台的载体中进行集成管理，并搭建与之配套的网络体系。',
        sydq: '适用地区：中国游客目的地',
        hzyq: '合作要求：当地有支付、收单受理资质',
        sycj: '使用场景',
        wscp: '完善的产品',
        aq: '安全'
      },
      DistributionPlatform: {
        cpdy: '产品定义',
        tyyxfw: '统一营销服务平台以供应链系统为支撑，是基于现代互联网技术的多渠道模式统一营销服务管理体系。整合线上与线下交易模式，覆盖企业经营管理应用各个方面。统一营销服务管理能有效掌控通路情况，敏捷捕捉消费者需求，快速响应市场变化，规避经营风险；以市场为导向，优化部署营销资源，协同产销、供应与服务，帮助企业构建敏捷的经营管理平台；通过电子商务等创新通路模式整合流通企业上下游产业链资源，共享数据与服务，提升供应链效率。',
        ywjs: '业务介绍',
        yxhd: '营销活动',
        gjqy: '可以根据企业的经营目标和策略，兼顾各市场的差异性，实现市场活动的计划性  。按不同的市场活动要求，根据活动的范围、活动的对象，活动的目标建立相应的业务流程。根据不同的区域、不同的品种、不同的渠道及终端建立有差别的审批机制。对活动的有效监督。提高活动效率，避免虚假行为。',
        khfw: '客户服务',
        ckhy: '对持卡会员提供全服务过程追踪，记录服务过程中服务生命周期状态变化情况;根据服务类型、服务周期、服务过程损耗和人员投入等信息反馈，促进对会员卡产品制定、会员卡分级管理、会员卡续约政策、会员服务过程改进等多方面优化和完善。',
        ckps: '仓库配送',
        wlwl: '支持物流网络的规模化的协同运作，提升供应链物流运作柔性，适应满足物流产业复合性特点，提高物流网络运作的实时性和整体效益;支持物流网络的规模化的协同运作，提升供应链物流运作柔性，适应满足物流产业复合性特点，提高物流网络运作的实时性和整体效益。',
        jtyx: '集团营销',
        xsyw: '通过销售业务政策管理、业务流程规范、商务协同应用，帮助构建集团企业销售与分销业务经营管理平台，提升经营绩效，优化资源配置，满足客户需求，降低运营成本。',
        dzsw: '电子商务',
        yyty: '用友统一营销平台提供B2B电子采购、B2B、B2C电子销售等全程 电子商务解决方案，为商业创新企业提供E+E：(电子商务EC+ERP)、O+O：(线上Online+线下Offline)'
      },
      EwalletPayment: {
        hwdzqb: '海外电子钱包支付解决方案',
        jrfw: '海外电子钱包金融服务（支付）平台就是互联网技术和金融功能的有机结合，包括基于网络平台的金融市场体系、金融服务体系、金融组织体系、金融产品体系以及互联网金融监管体系等，并具有平台金融、信息金融和碎片金融等相异于传统金融的金融模式。',
        jrzc: '海外电子钱包金融服务(支付)平台最终发展为集成金融众筹、金融流通（支付、转账、提现）、金融收益、金融清结算、金融信贷、金融分控等闭环金融生态圈，切实改变广大人民的消费、理财、购物等生活方式，实现海外国家利益再分配，最终实现集团、广大人民、海外国家等双赢。',
        rz: '融资',
        tzlc: '投资理财',
        yx: '营销',
        shjf: '生活缴费',
        xyk: '信用卡',
        xfzf: '消费支付',
        xyzf: '信用支付',
        zjgl: '资金管理',
        kh: '客户',
        ff: '丰富',
        ht: '互通',
        jz: '集中',
        gl: '关联',
        lh: '灵活',
        yq: '要求',
        ykhwzx: '以客户为中心',
        zhjzgl: '账户集中管理',
        zhjrfw: '综合金融服务',
        ydx: '移动性',
        dzh: '定制化',
        jsx: '及时性',
        jcx: '集成性'
      },
      InternetPayment: {
        zffz: '互联网支付发展',
        hlwzy: '网银、第三方支付、移动支付作为互联网支付的主要表现形式。互联网支付就属于那种需要特别“照顾”的。因为从微观层面上说，互联网支付直接涉及到用户的财产安全等切身利益，从宏观层面上，还关系到国家金融体系的稳定。例如第三方支付公司拥有巨额的沉淀资金，获得了开展金融业务的潜在能力，能够对整个金融体系产生影响。从保证国家金融安全的角度看，政府监管肯定是必要的。',
        bkbm: '当支付遇到互联网，一场革命自然不可避免。成为现实的是传统的现金支付已经“退居二线”，各种在线支付方式成为人们日常消费的主要支付方式。银行推出的网银以及民营企业推出的各种各样的第三方支付平台大大方便了人们的生活，互联网支付终端也从桌面电脑扩展到移动终端和电视等多种形式的终端上，互联网支付变得无处不在。',
        zftd: '互联网行业支付特点',
        zjdtx: '互联网支付属于电子支付方式的一种，因而具有电子支付的特征，但因其与移动通信技术、无线射频技术、互联网技术相互融合，又具有自己的特征。',
        ydx: '1.随身携带的移动性，消除了距离和地域的限制。结合了先进的移动通信技术的移动性，随时随地获取所需要的服务、应用、信息和娱乐。',
        bssj: '2.不受时间地点的限制，信息获取更为及时，用户可随时对账户进行查询、转账或进行购物消费。',
        jdfb: '3.基于先进的移动通信技术和简易的手机操作界面，用户可定制自己的消费方式和个性化服务，账户交易更加简单方便。',
        sjwzt: '4.以手机为载体，通过与终端读写器近距离识别进行的信息交互，运营商可以将移动通信卡、公交卡、地铁卡、银行卡等各类信息整合到以手机为平台的载体中进行集成管理，并搭建与之配套的网络体系。',
        sycj: '使用场景',
        dcb: '低成本',
        zfqd: '完善的支付渠道接入，商家可以避免重复接入支付方式的巨大成本。',
        gx: '高效',
        jsjg: '收款即时有结果。',
        lhxg: '灵活性高',
        ywtd: '商家可根据自身的业务特点，对我们提供的支付能力进行灵活组合满足业务需要。',
        ds: '电商',
        wm: '外卖',
        wyc: '网约车'
      },
      ManagementPlatform: {
        shptgn: '商户平台功能',
        shpttd: '商户平台特点',
        mdgl: '门店管理',
        xzmd: '新增门店，配置口碑门店ID，管理门店信息',
        yhgl: '用户管理',
        xzyg: '新增员工，设置每个员工所属门店、角色以及不同权限',
        lsgl: '流水管理',
        ghyy: '商户可清楚了解每日资金流水，管理每个门店流水情况，了解门店经营情况，更好运营',
        cpgl: '产品管理',
        gzhgl: '申请公众号管理、大屏互动、打赏等各类营销产品并制定设置各个营销产品具体内容',
        lssj: '流水数据更清晰',
        ssck: '实时查看每笔订单，统计门店流程数据，数据图片清晰直观',
        cpzc: '多种营销产品支持',
        hdyx: '公众号管理、大屏互动游戏、打赏管理等支持商户更有效开展活动',
        zjjg: '多级组织架构',
        sjzb: '商家总部、商家门店多级组织统一管理，支持多级自定义设置'
      },
      MobilePayment: {
        ydzffz: '移动支付发展',
        ydzf: '移动支付也称为手机支付，就是允许用户使用其移动终端（通常是手机）对所消费的商品或服务进行账务付的一种服务方式。单位或个人通过移动设备、互联网或者近距离传感直接或间接向银行金融机构发送支指令产生货币支付与资金转移行为，从而实现移动支付功能。移动支付将终端设备、互联网、应用提供商及金融机构相融合，为用户提供货币支付、缴费等金融业务。',
        dzgz: '移动支付标准的制定工作已经持续了三年多，主要是银联和中国移动两大阵营在比赛。数据研究公司IDC的报告显示，2017年全球移动支付的金额将突破1万亿美元。强大的数据意味着，今后几年全球移动支付业务将呈现持续走强趋势。',
        zftd: '互联网行业支付特点',
        zffs: '移动支付属于电子支付方式的一种，因而具有电子支付的特征，但因其与移动通信技术、无线射频技术、互联网技术相互融合，又具有自己的特征。',
        ydxone: '1.随身携带的移动性，消除了距离和地域的限制。结合了先进的移动通信技术的移动性，随时随地获取所需要的服务、应用、信息和娱乐。',
        bssj: '2.不受时间地点的限制，信息获取更为及时，用户可随时对账户进行查询、转账或进行购物消费。',
        jdfb: '3.基于先进的移动通信技术和简易的手机操作界面，用户可定制自己的消费方式和个性化服务，账户交易更加简单方便。',
        sjwzt: '4.以手机为载体，通过与终端读写器近距离识别进行的信息交互，运营商可以将移动通信卡、公交卡、地铁卡、银行卡等各类信息整合到以手机为平台的载体中进行集成管理，并搭建与之配套的网络体系。',
        sycj: '使用场景',
        ydx: '移动性',
        dzh: '定制化',
        jsx: '及时性',
        jcx: '集成性'
      }
    }
  },
  // IT服务
  ITservice: {
    index: {
      fw: 'IT 服务',
      jsfw: 'IT 技术服务',
      yyzcfw: 'IT 运营支撑服务'
    },
    IToperative: {
      kjzfyy: '跨境支付运营',
      jhzfyy: '聚合支付运营',
      zjcgyy: '资金存管运营',
      kjdsyy: '跨境电商运营',
      AggregatePayment: {
        jgzftd: '聚合支付特点',
        bzsh: '帮助商户更好地提升收银效率，优化商户与支付通道的对接过程，为商户提供快捷、安全、可靠的支付服务，还将日常交易管理、查账对账、商品管理等集成到统一的管理平台，大大提高了商户运营效率。',
        ywjs: '业务介绍',
        hlwjr: '互联网金融平台的建设，打破原有的封闭体系，帮助银行转型，融入互联网生态。',
        spfw: '商品服务',
        sh: '商户',
        xsjhzf: '线上聚合支付',
        yh: '用户',
        dzqs: '对账清算',
        xxjhzf: '线下聚合支付',
        zfcp: '支付产品',
        jgzfpt: '聚合支付平台',
        cpys: '产品优势',
        dcjgl: '多层级管理',
        zcpt: '支持平台、运营公司、代理商、商户多层级业务运营、满足企业业务拓展需求。',
        dyhzf: '多元化支付',
        zcdzcj: '支持多种场景，即可进行互联网及移动平台支付结算，也可线下面对面扫码支付、刷卡支付，后台接入了多方支付通道。',
        dwdtj: '多维度统计',
        dycp: '多元产品具备完整的交易数据统计查询模块，能够从不同维度进行交易数据统计，为商户代理商及运营平台提供强大的数据支撑化支付。',
        zddz: '自动对账',
        yygs: '支持平台、运营公司、代理商、商户多层级业务运营、满足企业业务拓展需求。'
      },
      CrossborderEcommerce: {
        kjdste: '跨境电商特点',
        hyfx: '行业分析',
        zgqjsn: '在过去十几年中，电商行业在国内的发展一直处于上半场，这一方面来自于网民数量的增加，另一方面，消费者从线下转到线上的消费需求，通过电商找到出口得到更好的满足。现在电商平台更加多样化，更加兴趣化。比如:最典型的社交红人大V变现之路，他们在平台上充分互动，从而在平台中产生爆发性的销售高峰。',
        ywjs: '业务介绍',
        zgdyp: '中国第一批代购跨境电商，连接跟代购有关的一切。',
        cpdw: '产品定位',
        mzyx: '满足一些用户需要购买境外的产品需求，以境外线下店铺为主，提供高品质购物的同时，提供了买手服务。',
        spfk: '商品付款',
        qrdgdd: '确认代购订单',
        wcdd: '完成订单',
        zf: '支付',
        fh: '发货',
        ms: '买手',
        kh: '客户',
        hqpt: 'HQ平台',
        dd: '订单',
        jh: '交货',
        qh: '取货',
        spje: '商品金额',
        dbje: '担保金返还/代购费',
        sj: '商家',
        cpys: '产品优势',
        xsgl: '销售管理',
        kfzx: '客服在线服务',
        gxck: '高效仓库',
        fxsj: '分析数据',
        gzl: '工作流',
        shcl: 'CRM售后处理',
        ckgl: 'FBA仓库管理',
        ddlr: '订单利润',
        gnxzs: '功能小助手'
      },
      CrossBorderPayment: {
        kjzftd: '跨境支付特点',
        hlwkjzf: '互联网跨境支付业务全面整合了中国银联、境内发卡银行和境外主流银行卡收单服务机构三方资源，具有商户资源全球覆盖、交易支付安全便捷、业务流程统一规范等显著特点，深受广大银联卡持卡人信赖',
        zc: '注册',
        sk: '收款',
        tx: '提现',
        cpys: '产品优势',
        aqhg: '安全合规',
        ysgg: '严守各国当地金融法规确保资金安全，收款无忧',
        jdhs: '降低汇损',
        ygnzl: '与国内主流商业银行“现汇买入价”相比，汇率更具优势',
        txxs: '提现迅速',
        yzk: '以最快的速度将款项汇至您的账户',
        czbj: '操作便捷',
        dpt: '多平台、多账户统一管理商户后台实时查看到账信息',
        sfyh: '收费优惠',
        sxf: '手续费具有竞争优势收费透明，无隐形费用',
        xyjs: '响应及时',
        zrkf: '专人客服7*24小时实时响应'
      },
      DepositoryOperations: {
        zjcgyy: '资金存管运营',
        zjcgsz: '资金存管是指银行对合作平台出借人与借款人开立和使用的资金存管账户进行管理和监督，依照出借人与借款人向平台发出的指令，对两者资金进行存管、划付、核算和监督，平台作为纯粹的信息中介参与到交易之中，全程不触碰资金，所有资金流动均在银行体系内进行，从而真正做到了平台与用户资金完全隔离，有效杜绝了平台支配和挪用用户资金的风险。',
        qdmmht: '签订买卖合同',
        djzfjk: '对接支付接口',
        wccgjr: '完成存管接入',
        sycggn: '使用存管功能',
        cgyh: '存管银行',
        qdxy: '签订协议',
        ktcgzh: '开通存管账户',
        cpys: '产品优势',
        ywcj: '业务场景精确匹配',
        djdjyh: '对接多家银行存管产品，根据电商、直播、餐饮、众筹等行业的业务场景，为商户精准匹配资金存管银行，提供最契合的资金存管方案。',
        wxecjr: '无需二次接入',
        djhqpay: '对接HQPAY资金存管解决方案，可在支付交易成功的同时，自动完成存管账户内的资金及账务信息同步，无需重复接入。',
        zytdxy: '专业团队极速响应',
        hylx: '行业领先的产品、技术、客户成功团队极速响应，有效降低企业的时间和人力成本。'
      }
    },
    ITtech: {
      appkf: 'APP开发',
      xcx: '小程序',
      rjdzkf: '软件定制开发',
      kflc: '开发流程',
      AppDevelopment: {
        cpdy: '产品定义',
        bzqy: '帮助企业开发安卓和苹果应用，更有针对性在移动互联网抢占先机，夺取市场。APP创新性开发，始终是用户的关注焦点，而商用APP客户端的开发，在传统广告、传统互联网与移动互联网融……',
        cpys: '产品优势',
        kfal: '开发案例',
        slkk: '实力可靠',
        kfgs: '开发公司项目参与人员的综合素质、技术人员的技术是否过硬、是否有代表性案例等等，这些都能体现一个APP开发公司的综合实力。',
        chnl: '策划能力',
        gszlj: '公司在了解客户行业背景和App功能需求后，能否短期内迅速反应，拿出有价值有创意的策划方案，这是个App开发公司策划能力的体现。',
        xylh: '信用良好',
        kytg: '可以通过多种渠道去了解某个APP开发公司的信誉、口碑，是否有过不良记录等。',
        fwyz: '服务优质',
        rgs: '如果说雄厚的技术是个APP开发公司的硬实力，那么优质的服务就是其软力的体现。APP开发前期的沟通往往需要甲乙双方的沟通配合才能完成。',
        ptwt: '平台稳妥',
        kfgsxm: '开发公司项目参与人员的综合素质、技术人员的技术是否过硬、是否有代表性案例等等，这些都能体现一个APP开发公司的综合实力。'
      },
      DevelopmentProcess: {
        gt: '沟通',
        sj: '设计',
        kf: '开发',
        cs: '测试',
        jf: '交付',
        wh: '维护'
      },
      SmallApp: {
        xcxkf: '小程序开发',
        xcxs: '小程序是从微信中打开的APP，无需安装，用完即走。可以解决消费者因使用APP成本过高而不买账的问题，同时多一条路径触达消费者。',
        cpys: '产品优势',
        kflc: '开发流程',
        qqgt: '前期沟通',
        xqpg: '需求评估',
        uigh: 'UI规划',
        gngh: '功能规划',
        sjsj: '视觉设计',
        qdzz: '前端制作',
        jskf: '技术开发',
        cs: '测试',
        wcjf: '完成交付',
        cskj: '触手可及',
        bxyxz: '小程序不需要下载安装，用户扫一扫或者搜一下即可打开',
        gnff: '功能丰富',
        ksxdw: '可实现定位、语音、视频、IM聊天、重力感应、导航等与原生APP一样的功能',
        ywjz: '用完即走',
        yhbgx: '用户不用关心是否安装太多应用的问题小程序随时可用，又无需安装卸载',
        fxhl: '分享红利',
        fbfx: '小程序可方便分享到微信个人和群聊窗口，回话中点击即用，非常方便传播',
        xsxxdt: '线上线下打通',
        zjrk: '小程序最佳入口是扫描二维码，线下用户只需简单扫码，即可转换为小程序用户',
        yhtx: '开放的用户体系',
        wxdr: '小程序无需登录，直接采用微信账号体系，极大降低用户首次使用门槛，同时方便用户信息收集'
      },
      SoftwareCustomization: {
        rjdzkf: '软件定制开发服务',
        gjkhxq: '可根据客户的需求，量身定制一系列符合客户实际应用的软件。目前的多数信息管理软件可以满足行业内的通用需求，而在特殊流程和客户定制上成本很高。对于中小企业来说,可以根据自己的实际业务需求，定制开发一套适合自己的软件。开发不求一步到位，一步步进行完善。如此，可以减少投入，并非常适合自身业务发展。',
        dzdjz: '定制的价值',
        ksld: '快速落地方案',
        qmfg: '全面覆盖需求',
        jzdw: '精准定位方向',
        zyln: '贯彻专业理念',
        wmdys: '我们的优势',
        zdxq: '针对性强',
        dzrj: '定制软件因为是量身定做的所以针对性非常强这也是定制软件最大优势',
        xjbg: '性价比高',
        dzkf: '定制开发的软件较于购买的通用型软件更具高性价比,更专业适用',
        gxlx: '高效率性',
        gjqy: '根据企业需求专业定制的软件，在操作使用方面更加的方便和快捷，提高了效率',
        kkzx: '可拓展性',
        rjxt: '软件系统可运行在开源平台或商业平台上，井且可应用多种成熟的开源系统架构'
      }
    }
    //
  },
  // 合作伙伴
  CooperativeTranslation: {
    ryzs: '荣誉证书',
    hzhb: '合作伙伴',
    gxjsqy: '高新技术企业证书',
    qyxydj: '企业信用等级证书',
    cmmi: 'CMMI认证证书',
    xxaq: '信息安全管理体系认证证书',
    zlgl: '质量管理体系认证证书',
    xxaqgl: '信息安全管理体系认证证书',
    zxqy: '创新型中小企业证书',
    zjtxzxqy: '专精特新中小企业证书'
  },
  // 关于泓齐
  AboutUs: {
    nav: {
      qywh: '优秀的企业文化',
      fwtd: '一流的服务态度',
      jstd: '专业的技术团队',
      zzgc: '精细的制作流程'
    },
    company: '泓齐网络科技有限公司',
    p1: '泓齐网科成立于2017年3月,',
    p2: '由崇尚极致、追求创新的团队打造而成，',
    p3: '专业为国内外金融机构',
    p4: '提供高效技术支持、优质咨询服务',
    p5: '的创新型公司。',
    p6: '以互联网金融创新服务为目标，紧跟国家“一带一路”发展战略，',
    p7: '力求',
    p8: '把先进的产品理念、精湛的技术和良好的服务带给全球客户。',
    p9: '业务分布',
    p10: '中国大陆、港澳台、东南亚及非洲地区等地',
    p11: '公司始终秉承“专业、专注、专家”的理念，打造令用户满意、合作伙伴信任、公司健康成长、员工快乐工作的持续性发展公司。面对未来，我们将以“安全、高效、优质”为发展宗旨，不断追求行业信息技术应用的创新，成为全球移动支付和金融科技行业服务价值的创造者与领先者。',
    p12: '我们',
    p13: '的',
    p14: '理念',
    gyhq: '关于泓齐',
    szhq: '深圳市泓齐网络科技有限公司(简称：HQPAY)成立于2017年3月，由崇尚极致、追求创新的团队打造而成，是',
    yjzy: '一家专业为国内外金融机构提供高效技术支持、优质咨询服务的创新型公司。',
    yhlw: '以互联网金融创新服务为目标，紧跟国家“一带一路”发展战略，公司业务目前主要分布中国大陆、港',
    atdny: '澳台、东南亚及非洲地区等地，力求把先进的产品理念、精湛的技术和良好的服务带给全球客户。',
    yxqy: '优秀的企业文化',
    ylfw: '一流的服务态度',
    zyjs: '专业的技术团队',
    jxzz: '精细的制作流程',
    azkf: 'Android开发工程师',
    azkf1: '具有大型互联网客户端APP或各类SDK开发经验;',
    azkf2: '精通Android开发，了解Android框架对Android系统应用管理、进程管理、内存管理等机制有深入理解;',
    azkf3: '熟悉Spring Cloud等Java开源框架，熟练AIDL，NDK开发深入理解面向对象的设计思想，常用设计模式;',
    azkf4: '熟练掌握TCP/IP/UDP，http，https等网络协议;',
    azkf5: '3-5年互联网金融App相关项目经验;',
    azkf6: '3-5年互联网金融App相关项目经验;',
    azkf7: '有大型APP架构设计经验经验者优先。',
    qdkf: 'Web前端开发工程师',
    qdkf1: '本科及以上；毕业证满一年',
    qdkf2: '1年以上前端工作经验，扎实的JavaScript基本功，精通BOM，DOM，HTML5,CSS3； 熟悉使用React',
    qdkf3: '在实际项目中，有过ReactNative开发经验 ，具有前后端分离经验，良好的编码习惯',
    qdkf4: '熟练使用webpack； 了解前端性能调优； 熟练使用Git。 最近半年内必须使用React技术栈开发',
    qdkf5: '具备良好的团队协作精神，能利用自身技术能力提升团队整体研发效率',
    qdkf6: '对技术有激情，喜欢钻研，能快速接受和掌握新技术，有较强的独立、主动学习能力，良好的沟通表达能力和团队协作能力',
    jakf: 'JAVA开发工程师',
    jakf1: '本科及以上学历，3年以上工作经验，计算机、软件工程、信息系统等相关专业',
    jakf2: '3年及以上JAVA经验，熟悉Spring,Struts,iBatis及至少一种Java 应用服务器如tomcat,jetty',
    jakf3: '3年以上互联网行业大型企业应用系统开发相关经验，扎实的基础知识。有高并发及亿级数据项目经验优先',
    jakf4: '熟练掌握MYSQL或Oracle等数据库技术,具有数据库使用调优能力。熟悉mongodb、tidb者优先',
    jakf5: '熟悉服务化框架，如springcloud,tinygroup,webservice，hessian，dubbo等',
    jakf6: '熟悉Linux常用命令，能独立在上面进行开发，测试和部署',
    jakf7: '有良好的沟通能力和较强的责任心和学习能力',
    jakf8: '熟悉云框架以及分布式应用系统设计开发',
    jakf9: '有良好编码规范及文档编写习惯',
    zpzg: '招聘主管',
    zpzg1: '具有大型互联网公司人事工作经验优先',
    zpzg2: '熟悉人力资源六大模块，精通招聘模块以及员工关系管理',
    zpzg3: '具备较好的表达、沟通、组织、协调能力和时间管理能力',
    zpzg4: '执行力强，愿意不断学习并提升自己的综合技能',
    zpzg5: '良好的宏观把握及大局观、系统管理、团队建设能力，优秀的制度建设及推进能力，计划、组织、统筹、协调、沟通、激励能力强',
    zpzg6: '具备良好的学习能力、执行力和抗压能力',
    sjzy: '世纪之约-中秋遇国庆',
    sshq: '盛世泓齐 龙腾网科',
    jqdl: '激情点亮新年,欢乐尽在泓齐',
    rlqz: '热烈庆祝泓齐网络科技有限公司乔迁之喜',
    gssz: '公司始终秉承“专业、专注、专家”的理念，打造令用户满意、合作伙伴信任、公司健康成长、员工快乐工作的持续性发展公司。面对未来，我们将以“安全、高效、优质”为发展宗旨，不断追求行业信息技术应用的创新，成为全球移动支付和金融科技行业服务价值的创造者与领先者。',
    qqyd: '全球移动支付',
    gszl: '公司致力于通过灵活稳定的业务经验和技术架构，让银行和其他金融企业享有互联网金融及支付领域的专业系统服务，互联网金融及支付领域的专业系统服务。持续挖掘金融行业痛点，秉承“专注创造产品价值”的服务核心，积极推动技术、产品、用户体验等全方位创新，为客户提供一站式产品、技术解决方案服务，致力于让金融与互联网产品结合的更为紧密。',
    hlwjr: '互联网金融行业解决方案',
    szjj: '随着经济快速发展，中国出境游消费达千亿美元，在整体旅游营收中占比在不断提升。为解决商家和银行在支付和结算过程中遇到诸多不便的问题，公司致力于与海外、当地合法金融机构（银行、清算组织、第三方支付机构）合作，共同发展全球移动支付业务。公司的业务支付场景，包括收银系统，智能POS，聚合二维码台卡，线上支付等，支持各种复杂的业务场景，响应时间迅速，处理结果安全可靠，迎合了中小商户和消费者群体的需求，以提供在线支付综合解决方案的方式解决了支付场景“碎片化”的痛点。同时，公司致力于将中国的普惠金融理念带向全球其他的国家和地区，结合当地的实际情况，联合当地政府和企业，以科技为载体，提高了当地居民生活、工作的便利性。',
    zqygq: '世纪之约-中秋遇国庆 你准备好了吗',
    hqwk: '泓齐网科',
    zzmnd: '在这么难得的节日里，我们相聚在一起，作为泓齐网科的大家庭肯定要琢磨着为家人们送点什么来应应节？来，跟着小编往下看。',
    nywjjs: '你以为这样就结束了吗？',
    rwmjx: '让我们继续一探究竟……',
    smewm: "扫描上方二维码关注'泓齐网科'微信公众号",
    cjyx: '辞旧迎新，继往开来',
    nrdjd: '2020迎新晚会于2020年01月11日在“南蓉大酒店”圆满举行',
    jxry: '吉祥如意，金鼠伴你旺一年，一年比一年甜！在这辞旧迎新的时节，泓齐网科2020迎新晚会于2020年01月11日在“南蓉大酒店”圆满举行。公司的年会凝聚了各高层领导以及公司所有员工的智慧与汗水，是全体员工对2019年丰富经验的传承和2020年战略构想规划，也是全体员工共聚一堂喜迎新春的欢聚晚会。',
    zwhs: '在晚会上，CEO从整体运营布局的高度对公司2019年的工作总结，对2020年的工作作出了部署，使我们清晰的预测到未来工作中的机遇和挑战，让我们能够更加从容的完成2020年的工作目标！',
    gszsyyg: '2019年，公司在所有员工的共同努力下，克服重重困难，齐心协力圆满完成公司各项目标，涌现出很多优秀的管理者和优秀员工。作为员工学习的典范，公司对优秀管理者和优秀员工进行表彰，激励优秀者以更加积极主动的工作态度、更加严谨负责的工作精神为泓齐网科发展添砖加瓦。',
    hqygdtj: '“盛世泓齐 龙腾网科”在迎新晚会集中体现了泓齐员工的团结、和谐、活泼、智慧的魅力，尤其是演员人的牺牲。员工在下班时间进行排练，他们经过无数个夜晚用心排练，不怕困难、艰辛付出，才有了我们这么一场欢乐精彩的晚会。',
    ffyw: '回首2019年，我们奋发有为、硕果累累；展望2020年，我们机遇与挑战并存、任重远道。在新的一年里，我们泓齐网科将继续发扬团结拼搏、开拓创新的工作作风，继续保持同心同德的合作精神，勇往直前的拼搏精神，以高度的责任感和强烈的事业心，百尽竿头更进一步，再攀公司发展新高峰！',
    lwb: '力王杯',
    qhdyj: '庆贺第一届泓齐网科“力王杯”奥运联赛圆满结束',
    wffyg: '为丰富员工文化生活，让员工在紧张的工作之余也放松心情，同时增强公司凝聚力，提高员工对优秀企业文化的共建锻造和继承，并为同事间相互交流、进一步认识提供机会，集体活动让全体员工和管理人员陶冶情操、减轻压力，激发热爱生活、热爱岗位的工作热情，更让大家进一步了解公司良好的发展态势，增强热爱劳务的热情，坚定和公司同步成长、同步发展的信心。同时在活动过程中增进同事之间的沟通交流、友谊，加强了解、交流工作管理心得。培育企业团结、奋进的团队精神，团队成员的密切配合，特举办此次运动会。',
    ccydh: '此次运动会项目多多，趣味多多，领导也跟员工投身其中，现场气氛热烈而和谐，欢呼声呐喊声不断，充分展现员工团结协作、积极向上、敢于拼搏的精神面貌。此次比赛项目有：吃西瓜、德州扑克、拖拉机扑克、跳棋、四国军棋、象棋、五子棋、羽毛球单双打、三人篮球、乒乓球、两人三足、赛车、LOL。一共13个项目，有益智类、体能类和电竞类三大项。集趣味性和竞技性于一体，体现了员工们的积极配合和努力拼搏、不服输的崇高精神。大家乐在其中，为享受运动的乐趣和争得集体的荣誉挥洒青春的汗水。',
    jqss: '激情四射的运动场',
    lwbj: '力王颁奖典礼',
    lwsqtyg: '【泓网科技】力王赛全体员工2018年大合影',
    rlzh: '热烈祝贺泓齐网科年会在清远圆满召开',
    qyfgb: '清远佛冈碧 · 桂园 · 清泉城，吃着火锅，品着美食，泓齐和鸣野的帅哥靓女们迎来了2018年年会的高潮 · 晚会，本次晚会安排了歌曲，小品，相声，游戏，抽奖等有趣的环节，节目精彩纷呈，高潮迭起，给在场的所有人带来了一场别开生面的视觉盛宴。整个晚会气氛活跃，让员工在欣赏节目的同时，收获一份感动，一份与企业心心相连的默契。',
    whcs: '晚会初始，泓齐网科CEO辉神发表新年贺词，祝福大家新年快乐的同时预祝两家公司在2018年红红火火、大展宏图。并以一首《咱们屯里的人》正式拉开晚会的帷幕。',
    sxdc: '首先登场的是爆笑又富有深刻寓意的小品《生活不止眼前的苟且》，众多心怀梦想的年轻人从五湖四海汇聚到深圳，形成了深圳独有的文化。几乎每一个来深圳的人，都会被人问过这样一句话：你为什么来深圳？同样，每一个离开深圳的人，也会被问到：你为什么要离开深圳？《生活不止眼前的苟且》帮大家找到了答案！大家在为之笑容失控时却又被触动心弦。',
    zdjsk: '在大家思考的同时，晚会迎来了第二个节目《动口不动手》，参与游戏的选手们纷纷展现出各自的默契与奇思妙想，充分展现了公司员工的合作与创新精神。',
    yxgh: '游戏过后的抽奖环节，更是扣人心弦，紧张万分，众多员工抱得大奖。',
    zyzswd: '在一众失望的眼神中，不一样的《新闻联播》登场了，在两位主持人一本正经的唇枪战后，带领大家再一次掀起热情的高潮。',
    zyphsxy: '在一片欢声笑语中，迎来了此次晚会压轴大戏 · 大型真人婚姻秀节目--《非诚勿扰》。伴随着《非诚勿扰》主持人-辉神帅气的发言，风靡全场的8位女嘉宾闪亮登场。她们展现着迷人的身姿，微微转身，台下男嘉宾心里早已按耐不住：“她转身，如碧波伴清澈的眼神，洋溢这淡淡的温馨，嘴角的弧度似月牙般完美，或许，这就是天使的微笑”。',
    zylld: '在一轮轮的男嘉宾展示自己魅力，表达自己真诚，却又铩羽而归。正验证了这么一句话“我抬着丘比特的箭追呀追，你穿着防弹背心跑呀跑”。或许是丘比特箭丢了，他直接出手了，新一轮男嘉宾上场，一位女生到最后留灯了，男嘉宾的心动女生也正是这位女嘉宾，真是“身无彩凤双飞翼，心有灵犀一点通”。',
    xcbf: '现场爆发出一阵阵惊叹。在惊叹的同时，最后一位男嘉宾登场了，他同样也被女嘉宾留灯，只是心动女生却不是她，“我本将心向明月，奈何明月照沟渠”。',
    mhdsk: '美好的时刻总是短暂的。晚会中不论是喜气洋洋的《咱们屯里的人》还是趣味盎然的《生活不止眼前的苟且》、奇思妙想的《动口不动手》、时尚潮流的《新闻联播》、真人秀的《非诚勿扰》、每一个都给大家带来了无尽的欢乐。',
    zhyhs: '最后由辉神上台，主持一等奖的抽奖，结束了2018年晚会。',
    bcwh: '本次晚会，在丰富了员工的文化生活，为员工提供了展示自己的舞台之时，也增强了泓齐的内部凝聚力，增进了员工对公司的认知和归属感。相信在未来的2018年，我们斗志昂扬！',
    wmbjl: '我们搬家了',
    rlqzhqwk: '热烈庆祝泓齐网络科技有限公司乔迁之喜',
    wxdgzhj: '导语：全新的工作环境，顶尖的工作团队，积极的工作态度……锣鼓喧天、鞭炮齐鸣，2018年4月17日，泓齐网络科技有限公司，我们搬家啦！经过公司全体同仁的齐心努力，泓齐网科顺利完成新址搬迁并恢复正常工作，由福田奥林匹克大厦搬迁至南山区桃源办平山大园工业区13栋（鸿莱科创楼）4楼405室，泓齐网络科技有限公司，我们搬家啦！经过公司全体同仁的齐心努力，泓齐网科顺利完成新址搬迁并恢复正常工作，由福田奥林匹克大厦搬迁至南山区桃源办平山大园工业区13栋（鸿莱科创楼）4楼405室，泓齐网络科技有限公司，我们搬家啦！经过公司全体同仁的齐心努力，泓齐网科顺利完成新址搬迁并恢复正常工作，由福田奥林匹克大厦搬迁至南山区桃源办平山大园工业区13栋（鸿莱科创楼）4楼405室。',
    xbgs: '新办公区宽敞明亮，环境怡人，一排排办公桌整齐而典雅，一缕阳光穿梭而留，这悄然惬意的一面，正如我们这个年轻的团队，创新今日，通向未来！新址所提供的更加现代化的办公条件和更加先进的办公设备为今后不断壮大企业实力打下了坚实的基础，也为年轻的我们提供了更好的战场。',
    zqhy: '整齐划一的办公区',
    hys: '会议室',
    ygxxq: '员工休闲区',
    ccqq: '此次乔迁，标志着泓齐网科从此又迈上了一个新的台阶，一次次辛勤的汗水换来的是一次次的飞跃。公司将以全新的面貌展现于同仁，以全新的理念和品质服务于我们的客户！看今朝，我们踌躇满志，展未来，我们豪情满怀！我们将以更加饱满的工作热情，良好的精神状态，打造泓齐网科全新的辉煌；以百倍的努力，共同创造美好未来！',
    gsdt: '公司动态',
    hqzp: '泓齐招聘',
    rzyq: '任职要求',
    lxwm: '联系我们',
    szshqwk: '深圳市泓齐网络科技有限公司（深圳公司总部）',
    gsdz: '公司地址：',
    gdsszs: '广东省深圳市南山区桃源办平山大园工业区13栋（鸿莱科创楼）4楼405室 518055',
    gsdh: '公司电话：',
    dl: '大陆',
    gsgw: '公司官网：',
    gsyx: '公司邮箱：',
    xggs: '香港公司',
    xg: '香港'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/zh-cn.js